import { BestSellingItem } from '../../../interfaces/entity-dashboard/BestSellingResponse';

/**
 * Calculates progress bar value for a selling item.
 *
 * The first-place item is anchored at 100% + its period-over-period diff,
 * so a positive diff overflows (clamped to 100 by LbLinearProgress) and a
 * negative diff shortens the bar proportionally.
 * All other items are scaled relative to the first-place total amount.
 */
export const calcSellingProgressValue = (
  item: BestSellingItem,
  topItem: BestSellingItem,
): number => {
  if (item.position === 1) {
    return 100 + topItem.revenue.diffPercent;
  }

  return (item.revenue.value / topItem.revenue.value) * 100;
};
